export { default as initFoxentry } from "./foxentry";
